<template>
  <div class="home-page">
    <TopNav class="top-nav-block" :profile-data="userProfilePayload" :unread-count="unreadCount" />
    <HomeInform class="content-block first-content-block" :profile-data="userProfilePayload" />
    <HomeCarousel v-if="homeCarouselList.length" class="content-block" :carousel-list="homeCarouselList" />
    <!-- <HomeTabs class="content-block" /> -->
    <HomeNews class="content-block" />
    <BottomNav />
  </div>
</template>

<script>
import BottomNav from '../component/BottomNav.vue';
import HomeInform from '../home/component/HomeInform.vue';
import HomeCarousel from '../home/component/HomeCarousel.vue';
import TopNav from '../home/component/TopNav.vue';
// import HomeTabs from '../home/component/HomeTabs.vue';
import HomeNews from '../home/component/HomeNews.vue';
import { getHomeInfo, getHomeLunboList, getMessageList } from '@/api';
import { getCachedUserProfile, setCachedUserProfile } from '@/utils/profile';

export default {
  name: 'HomePage',
  data() {
    return {
      userProfilePayload: getCachedUserProfile(),
      homeCarouselList: [],
      unreadCount: 0
    };
  },
  components: {
    BottomNav,
    HomeInform,
    HomeCarousel,
    TopNav,
    // HomeTabs,
    HomeNews
  },
  mounted() {
    this.fetchUserProfile();
    this.fetchHomeCarouselList();
    this.fetchMessageList();
  },
  methods: {
    async fetchMessageList() {
      try {
        const res = await getMessageList();
        this.unreadCount = res?.data?.unread || 0;
      } catch (error) {
        console.error(error);
      }
    },
    async fetchUserProfile() {
      try {
        const res = await getHomeInfo();
        const payload = res?.data || null;
        if (payload) {
          this.userProfilePayload = payload;
          setCachedUserProfile(payload);
        }
      } catch (error) {
        // 错误提示已在全局请求拦截器中统一处理
      }
    },
    async fetchHomeCarouselList() {
      try {
        const res = await getHomeLunboList();
        const list = Array.isArray(res?.data) ? res.data : [];
        this.homeCarouselList = list;
      } catch (error) {
        this.homeCarouselList = [];
      }
    }
  }
}
</script>


<style lang="scss" scoped>
.home-page {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  gap: 0;
  padding-bottom: 18vw;
  background: #f8f9fa;
  overflow-x: hidden;
}

.top-nav-block {
  width: 100%;
}

.content-block {
  width: 90%;
  margin: 0 auto;
}

.first-content-block {
  margin-top: 1vw;
}

.content-block + .content-block {
  margin-top: 5vw;
}
</style>